/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const GetLatestParams = zod.object({
  viewAsPrincipalType: zod
    .enum(['USER', 'GROUP', 'GROUP_MEMBER', 'PUBLIC'])
    .optional()
    .describe(
      'Principal to read as. Omitted, the caller reads as their own authenticated principal (PUBLIC when unauthenticated).',
    ),
  viewAsActorUuid: zod
    .uuid()
    .optional()
    .describe(
      'Group UUID for viewAsPrincipalType GROUP or GROUP_MEMBER. Ignored for PUBLIC; optional for USER (defaults to yourself).',
    ),
  accessGrantUuid: zod
    .uuid()
    .optional()
    .describe(
      'Share-link grant to read through. The read SQL unions it with the calling identity’s own permissions, so an authenticated caller keeps everything they could already see.',
    ),
});

export type GetLatestParams = zod.input<typeof GetLatestParams>;
export type GetLatestParamsOutput = zod.output<typeof GetLatestParams>;
